(function () {
  var CART_WRITE_PATTERN = /\/cart\/(add|update|change)(\.js)?(\?|$)/;
  var WARNING = 'B2B store: cart is disabled';

  function isCartWriteUrl(url) {
    return CART_WRITE_PATTERN.test(String(url));
  }

  // Read by assets/ga4-events.js as blocked buy intent. An app embed POSTs cart
  // attributes to /cart/update.js on its own, so fetch/XHR count only for /cart/add.
  function reportBlocked(type, url) {
    if ((type === 'fetch' || type === 'xhr') && !/\/cart\/add(\.js)?(\?|$)/.test(String(url))) return;
    document.dispatchEvent(new CustomEvent('b2b:cart-blocked', { detail: { type: type } }));
  }

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input) {
      var url = input && input.url ? input.url : String(input);
      if (isCartWriteUrl(url)) {
        console.warn(WARNING);
        reportBlocked('fetch', url);
        return Promise.reject(new Error(WARNING));
      }
      return originalFetch.apply(this, arguments);
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWriteUrl(url)) {
      console.warn(WARNING);
      reportBlocked('xhr', url);
      throw new Error(WARNING);
    }
    return originalOpen.apply(this, arguments);
  };

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart') !== -1 || form.getAttribute('data-type') === 'add-to-cart-form') {
        console.warn(WARNING);
        reportBlocked('form');
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')
        : null;
      if (target) {
        console.warn(WARNING);
        reportBlocked('checkout_click');
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();
